import { Component, OnInit } from '@angular/core';
//import { HEROES } from '../mock-heroes';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable } from 'rxjs';
import * as $ from 'jquery';
import { DISABLED } from '@angular/forms/src/model';
import {formatDate} from '@angular/common';


//import {} from 
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  //providers:  [ firebase ]
})

export class HomeComponent implements OnInit {
  //heroes = HEROES;
  constructor(private db:AngularFireDatabase) { }

  status : Observable<any[]>;
  selectedid : string;
  //userDetails: Observable<any[]>;
  
  users: Observable<any[]>;
  data:string;
  feedback: string;
  num: number;
  review: string;
  ukey:any;
  showReview:number;
  someField:string;
  someKeys:string;
  date:any;
  ngOnInit() {
    this.status = this.db.list("Status").snapshotChanges();
  }

  ClickButton(){
    alert('You add');
  }

  clicked(id: number){
    alert("hero id: "+id);
  }
  
  AddVehicle(vno:string,bay:number,ser:string,advisor:string,status:string,model:string){
    const reporting =this.db.list('Reporting');
    const data = this.db.object('Status/'+vno);
    this.date=formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if(vno){
      
       this.ukey=reporting.push({date:this.date,vehicleNo:vno,advName:advisor,bayNumber:bay,status:status,type:ser,model:model});
       if(this.ukey.key){
        data.update({ advName:advisor,bayNumber:bay,status:status,type:ser,model:model,reportingKey:this.ukey.key});
       } 
    }else{
      alert("Please Add Vehicle No");
    }
    /*
    this.ukey=reporting.push({date:this.date,vehicleNo:vno,advName:advisor,bayNumber:bay,status:status,type:ser,model:model});
       if(this.ukey.key){
        data.update({ advName:advisor,bayNumber:bay,status:status,type:ser,model:model,reportingKey:this.ukey.key});
       }
    */
  }

  saveData(stat:any,status:string,bay:number,type:string,adve:string,model:string,Keys:string){
    stat.isEditable=!stat.isEditable;
    const data = this.db.object('Status/'+stat.key);
    if(status=="Delivered"){
      this.showReview=1;
      this.someField=stat.key;
      this.someKeys=Keys;
    }else{
      this.showReview=0;
    }
    this.date=formatDate(new Date(), 'hh:mm a', 'en');
    let rKey = stat.payload.val().reportingKey;
    const repoUpdate = this.db.object('Reporting/'+ rKey);
      repoUpdate.update({ advName:adve,bayNumber:bay,type:type,model:model});
      data.update({ advName:adve,bayNumber:bay,status:status,type:type,model:model}); 
    const repoStatusup = this.db.list('Reporting/'+ rKey +'/log');
    repoStatusup.push({status:status,time:this.date});
    //console.log(rKey);
    // if(status == 'Delivered'){
    //     //alert("Thank You");
    //     //this.feedback = window.prompt("Give Your feedback \r 1 to 5");
    //     this.num= parseInt(this.feedback);
    //     if(this.num < 5){
    //      this.review = window.prompt('Give Your review');
    //      const data = this.db.object('Review/'+stat.key);
    //      data.update({rewiew:this.review});
    //     }else{
    //       data.update({status:status});
    //     }
    // }else{
    // data.update({status:status}); 
    //}
  }

  removeData(id: string){
    
      if(confirm("Remove from list "+ id)){
        const data = this.db.object('Status/'+id);
        data.remove();
      }
    
  }

  

  /*
  delivered(id:string){
      alert(id);
      console.log("Click Click");
  } */

  reviewClose(){
    this.showReview=0;
  }

  reviewSubmit(id:string,ukey:string,rating:number){
    
    // const review =this.db.list('Review');
    // review.push({vehicleNo:id,rating:rating});
    const data = this.db.object('Review/'+id);
    this.date=formatDate(new Date(), 'yyyy/MM/dd', 'en');
    data.update({rating:rating,date:this.date,reportingKey:ukey});
    this.showReview=0;
  }
  
 recentTime(){
 
  this.date=formatDate(new Date(), 'hh:mm', 'en');

  console.log(this.date);
  //alert(this.date);
   
 }
   

}
